import React, { FC } from 'react';
import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { WrappedFieldProps } from 'redux-form';
import i18n from '../../../i18n';

export interface TextAreaControlProps {
    label: string;
    // Optional:
    rows?: number;
    name?: string;
    value?: string;
    onChange?: any;
    maxLength?: number;
    errorMessage?: string;
    fullWidth?: boolean;
    isDisabled?: boolean;
    helperText?: string;
}

const useInputStyles = makeStyles(theme => ({
    root: {
        borderRadius: theme.spacing(0.75),
    },
}));

const useLabelStyles = makeStyles({
    root: {
        transform: 'translate(12px, 15px)',
    },
});

export const TextAreaControl: FC<TextAreaControlProps> = props => {
    const inputClasses = useInputStyles();
    const labelClasses = useLabelStyles();
    const { errorMessage, rows, maxLength, isDisabled, helperText, ...rest } = props;
    return (
        <TextField
            InputProps={{ disableUnderline: true, classes: inputClasses }}
            inputProps={{ maxLength }}
            InputLabelProps={{ classes: labelClasses }}
            multiline={true}
            rows={rows ? rows : 3}
            variant="filled"
            disabled={isDisabled}
            error={!!errorMessage}
            helperText={errorMessage ? errorMessage : helperText}
            fullWidth={true}
            size="small"
            {...rest}
        />
    );
};

export interface TextAreaControlFieldOwnProps {
    label: string;
    // Optional
    isDisabled?: boolean;
    rows?: number;
    maxLength?: number;
    helperText: string;
}

export type TextAreaControlFieldProps = TextAreaControlFieldOwnProps & WrappedFieldProps;

export const TextAreaControlField = (props: TextAreaControlFieldProps) => {
    const { t } = i18n.useTranslation();
    const {
        input,
        label,
        isDisabled,
        rows,
        maxLength,
        meta: { touched, invalid, error },
        helperText,
        ...rest
    } = props;

    return (
        <TextAreaControl
            label={label}
            isDisabled={isDisabled}
            rows={rows}
            maxLength={maxLength}
            helperText={helperText}
            errorMessage={touched && invalid ? t(error) : undefined}
            {...input}
            {...rest}
        />
    );
};
